import { useT } from "../../../../i18n/I18nProvider";
import { Card, CardHead } from "../../../ui";
import type { DashActivityDay } from "../../../../lib/dashboard";

const BARS = [
  { key: "calls", color: "var(--color-primary)" },
  { key: "mails", color: "var(--color-primary-2)" },
  { key: "tasks", color: "var(--color-success)" },
] as const;

/**
 * The week's own output: calls placed, mail sent, tasks finished.
 *
 * All three share one scale, taken from the busiest bar in the window. Scaling
 * each series to its own maximum would make four calls and forty mails draw the
 * same height, which is the one comparison this chart exists to allow.
 */
export function ActivityCard({ activity }: { activity: DashActivityDay[] }) {
  const t = useT();
  const peak = Math.max(1, ...activity.flatMap((d) => [d.calls, d.mails, d.tasks]));
  const weekday = (iso: string) => new Date(iso).toLocaleDateString("et-EE", { weekday: "short" }).slice(0, 1).toUpperCase();

  return (
    <Card>
      <CardHead title={t("dash.activity.title")} sub={t("dash.activity.sub")} />
      <div className="crm-bars">
        {activity.map((day) => (
          <div key={day.day} className="crm-bcol">
            <span className="crm-bgrp">
              {BARS.map((bar) => (
                <i
                  key={bar.key}
                  title={`${t(`dash.activity.${bar.key}`)}: ${day[bar.key]}`}
                  style={{ height: `${Math.max(2, (day[bar.key] / peak) * 100)}%`, background: bar.color }}
                />
              ))}
            </span>
            <span className="crm-blab">{weekday(day.day)}</span>
          </div>
        ))}
      </div>
      <div className="crm-legend" style={{ padding: "6px 26px 22px", gap: 16 }}>
        {BARS.map((bar) => (
          <span key={bar.key}>
            <i style={{ background: bar.color }} />
            {t(`dash.activity.${bar.key}`)}
          </span>
        ))}
      </div>
    </Card>
  );
}
